import React from "react";
import RegisterForm from "../components/RegisterForm";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const Register = () => {
  const [loaded, setLoaded] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) navigate("/");
  }, [navigate]);

  useEffect(() => {
    requestAnimationFrame(() => setTimeout(() => setLoaded(true), 50));
  }, []);

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Inter:wght@300;400;500&display=swap');

    /* ═══ NAV ═══ */
    .ar-nav {
      position: fixed; top: 0; left: 0; right: 0;
      z-index: 100;
      background: rgba(250,247,242,0.92);
      backdrop-filter: blur(30px);
      -webkit-backdrop-filter: blur(30px);
    }
    .ar-nav-inner {
      max-width: 1400px; margin: 0 auto;
      padding: 28px 48px;
      display: flex; align-items: center; justify-content: space-between;
    }
    .ar-nav-logo {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 22px; font-weight: 400;
      letter-spacing: 5px; text-transform: uppercase;
      color: #074F4F;
      text-decoration: none;
    }
    .ar-nav-links { display: flex; gap: 44px; list-style: none; padding: 0; margin: 0; }
    .ar-nav-links a {
      font-family: 'Inter', sans-serif;
      font-size: 12px; font-weight: 500;
      letter-spacing: 2px; text-transform: uppercase;
      color: #2d2d2d;
      text-decoration: none;
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      position: relative;
      padding-bottom: 4px;
    }
    .ar-nav-links a::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0;
      width: 100%; height: 1px;
      background: #074F4F;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-nav-links a:hover::after { transform: scaleX(1); transform-origin: left; }
    .ar-nav-links a:hover { color: #074F4F; }
    .ar-nav-auth { display: flex; align-items: center; gap: 20px; }
    .ar-nav-login {
      font-family: 'Inter', sans-serif;
      font-size: 11px; font-weight: 500;
      letter-spacing: 2px; text-transform: uppercase;
      color: #8a8a8a;
      text-decoration: none;
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      position: relative;
      padding-bottom: 4px;
    }
    .ar-nav-login::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0;
      width: 100%; height: 1px;
      background: #C6A769;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-nav-login:hover::after { transform: scaleX(1); transform-origin: left; }
    .ar-nav-login:hover { color: #C6A769; }
    .ar-nav-toggle {
      display: none; flex-direction: column; justify-content: center; align-items: center;
      gap: 5px; width: 40px; height: 40px; background: none; border: none; cursor: pointer; z-index: 210;
    }
    .ar-nav-toggle span { display: block; width: 24px; height: 1.5px; background: #074F4F; transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1); }
    .ar-nav-toggle.open span:nth-child(1) { transform: translateY(6.5px) rotate(45deg); }
    .ar-nav-toggle.open span:nth-child(2) { opacity: 0; }
    .ar-nav-toggle.open span:nth-child(3) { transform: translateY(-6.5px) rotate(-45deg); }
    .ar-nav-mobile {
      display: none; flex-direction: column; background: #FAF7F2; max-height: 0; overflow: hidden;
      transition: max-height 0.5s cubic-bezier(0.16, 1, 0.3, 1); box-shadow: 0 12px 30px rgba(7,79,79,0.1);
    }
    .ar-nav-mobile.open { max-height: 400px; }
    .ar-nav-mobile-links { list-style: none; display: flex; flex-direction: column; padding: 12px 24px; margin: 0; }
    .ar-nav-mobile-links li { border-bottom: 1px solid rgba(7,79,79,0.06); }
    .ar-nav-mobile-links li:last-child { border-bottom: none; }
    .ar-nav-mobile-links a {
      display: block; padding: 16px 4px; font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 500;
      letter-spacing: 1px; text-transform: uppercase; color: #2d2d2d; text-decoration: none;
    }
    .ar-nav-mobile-links a:hover { color: #074F4F; }
    .ar-nav-mobile-auth { padding: 16px 24px 28px; }
    .ar-nav-mobile-auth .ar-nav-login { display: block; text-align: center; padding: 10px; }
    .ar-nav-mobile-scrim {
      position: fixed; inset: 0; z-index: 90; background: rgba(7,79,79,0.3);
      opacity: 0; visibility: hidden; transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-nav-mobile-scrim.open { opacity: 1; visibility: visible; }

    /* ═══ FOOTER ═══ */
    .ar-footer {
      background: #074F4F;
      padding: 80px 48px 32px;
    }
    .ar-f-inner { max-width: 1200px; margin: 0 auto; }
    .ar-f-grid {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr;
      gap: 48px; margin-bottom: 56px;
    }
    .ar-f-brand-name {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 22px; font-weight: 400;
      letter-spacing: 5px; text-transform: uppercase;
      color: #FAF7F2; margin-bottom: 14px;
    }
    .ar-f-brand p {
      font-family: 'Inter', sans-serif;
      font-size: 13px; line-height: 1.7;
      color: rgba(250,247,242,0.4); max-width: 260px;
    }
    .ar-f-social { display: flex; gap: 16px; margin-top: 24px; }
    .ar-f-social a {
      width: 36px; height: 36px;
      border: 1px solid rgba(198,167,105,0.25);
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-family: 'Inter', sans-serif;
      font-size: 11px; letter-spacing: 1px; text-transform: uppercase;
      color: rgba(250,247,242,0.5); text-decoration: none;
      transition: all 0.3s;
    }
    .ar-f-social a:hover { background: #C6A769; border-color: #C6A769; color: #074F4F; }
    .ar-f-col h5 {
      font-family: 'Inter', sans-serif;
      font-size: 10px; font-weight: 500;
      letter-spacing: 2px; text-transform: uppercase;
      color: #C6A769; margin-bottom: 20px;
    }
    .ar-f-col ul { list-style: none; padding: 0; margin: 0; }
    .ar-f-col li { margin-bottom: 12px; }
    .ar-f-col a { font-family: 'Inter', sans-serif; font-size: 13px; color: rgba(250,247,242,0.4); text-decoration: none; transition: color 0.3s; }
    .ar-f-col a:hover { color: #C6A769; }
    .ar-f-divider { height: 1px; background: linear-gradient(90deg, transparent, rgba(198,167,105,0.2), transparent); margin-bottom: 32px; }
    .ar-f-bottom { display: flex; justify-content: space-between; font-family: 'Inter', sans-serif; font-size: 11px; color: rgba(250,247,242,0.25); }
    .ar-f-bottom a { color: rgba(250,247,242,0.25); margin-left: 20px; text-decoration: none; transition: color 0.3s; }
    .ar-f-bottom a:hover { color: #C6A769; }

    /* ═══ GRAIN ═══ */
    .ar-grain {
      position: fixed; inset: 0; z-index: 10;
      pointer-events: none; opacity: 0.02;
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
      background-size: 128px;
    }

    /* ═══ SCENE ═══ */
    .ar-scene {
      min-height: 100vh;
      padding-top: 100px;
      padding-bottom: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      overflow: hidden;
      background: #FAF7F2;
    }
    .ar-scene::before {
      content: '';
      position: absolute;
      top: -20%; right: -10%;
      width: 600px; height: 600px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(218,235,219,0.25) 0%, transparent 70%);
      pointer-events: none;
    }
    .ar-scene::after {
      content: '';
      position: absolute;
      bottom: -15%; left: -8%;
      width: 500px; height: 500px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(245,225,208,0.2) 0%, transparent 70%);
      pointer-events: none;
    }

    .ar-layout {
      max-width: 1100px;
      width: 100%;
      margin: 0 auto;
      padding: 60px 48px;
      display: grid;
      grid-template-columns: 1fr 1.2fr;
      gap: 80px;
      align-items: center;
      position: relative;
      z-index: 2;
    }

    /* ─── LEFT: BRAND ─── */
    .ar-brand {
      opacity: 0;
      transform: translateY(40px);
      transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.2s;
    }
    .ar-scene.loaded .ar-brand { opacity: 1; transform: translateY(0); }
    .ar-brand-tag {
      font-family: 'Inter', sans-serif;
      font-size: 10px; font-weight: 500;
      letter-spacing: 4px; text-transform: uppercase;
      color: #C6A769;
      margin-bottom: 24px;
    }
    .ar-brand h1 {
      font-family: 'Cormorant', Georgia, serif;
      font-size: clamp(40px, 5vw, 60px);
      font-weight: 300;
      color: #074F4F;
      line-height: 1.05;
      letter-spacing: -0.03em;
      margin-bottom: 28px;
    }
    .ar-brand h1 em { font-style: italic; font-weight: 300; color: #C6A769; }
    .ar-brand-line {
      width: 60px; height: 1px;
      background: #C6A769;
      margin-bottom: 28px;
      transform: scaleX(0); transform-origin: left;
      transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1) 0.6s;
    }
    .ar-scene.loaded .ar-brand-line { transform: scaleX(1); }
    .ar-brand-quote {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 20px; font-weight: 300; font-style: italic;
      line-height: 1.6; color: #8a8a8a; max-width: 380px;
    }
    .ar-brand-author {
      margin-top: 16px;
      font-family: 'Inter', sans-serif;
      font-size: 10px; letter-spacing: 3px; text-transform: uppercase;
      color: #b5b5b5;
    }

    /* ─── RIGHT: FORM CARD ─── */
    .ar-form-wrap {
      opacity: 0;
      transform: translateY(40px);
      transition: all 1s cubic-bezier(0.16, 1, 0.3, 1) 0.4s;
    }
    .ar-scene.loaded .ar-form-wrap { opacity: 1; transform: translateY(0); }
    .ar-card {
      background: #fff;
      padding: 48px 44px;
      position: relative;
      box-shadow:
        0 1px 3px rgba(7,79,79,0.02),
        0 8px 32px rgba(7,79,79,0.04),
        0 24px 60px rgba(7,79,79,0.03);
    }
    .ar-card::before {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 2px;
      background: #C6A769;
      transform: scaleX(0); transform-origin: left;
      transition: transform 1.2s cubic-bezier(0.16, 1, 0.3, 1) 0.8s;
    }
    .ar-scene.loaded .ar-card::before { transform: scaleX(1); }

    .ar-card-head { margin-bottom: 32px; }
    .ar-card-head h2 {
      font-family: 'Cormorant', Georgia, serif;
      font-size: 32px; font-weight: 300;
      color: #074F4F; letter-spacing: -0.02em; margin-bottom: 6px;
    }
    .ar-card-head p {
      font-family: 'Inter', sans-serif;
      font-size: 13px; font-weight: 300; color: #8a8a8a;
    }

    /* form grid */
    .ar-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
    .ar-grid .ar-field.full {
      grid-column: 1 / -1;
    }

    /* inputs */
    .ar-field { position: relative; }
    .ar-label {
      display: block;
      font-family: 'Inter', sans-serif;
      font-size: 9px; font-weight: 500;
      letter-spacing: 3px; text-transform: uppercase;
      color: #074F4F;
      margin-bottom: 10px;
    }
    .ar-input-wrap { position: relative; }
    .ar-input {
      width: 100%;
      height: 48px;
      padding: 0 16px;
      font-family: 'Inter', sans-serif;
      font-size: 14px; font-weight: 300;
      color: #2d2d2d;
      background: #FAF7F2;
      border: 1px solid transparent;
      border-radius: 0;
      outline: none;
      transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      -webkit-appearance: none;
    }
    .ar-input:focus {
      background: #fff;
      border-color: #C6A769;
      box-shadow: 0 0 0 3px rgba(198,167,105,0.06);
    }
    .ar-input::placeholder { color: #b5b5b5; font-weight: 300; }
    .ar-eye {
      position: absolute;
      right: 14px; top: 50%;
      transform: translateY(-50%);
      background: none; border: none;
      cursor: pointer; color: #b5b5b5;
      padding: 4px; display: flex; align-items: center;
      transition: color 0.3s;
    }
    .ar-eye:hover { color: #074F4F; }

    /* field error */
    .ar-field-error {
      font-family: 'Inter', sans-serif;
      font-size: 11px; color: #b33;
      margin-top: 6px;
    }

    /* validation checklist */
    .ar-checks {
      display: flex;
      flex-direction: column;
      gap: 5px;
      margin-top: 8px;
    }
    .ar-check {
      display: flex;
      align-items: center;
      gap: 8px;
      font-family: 'Inter', sans-serif;
      font-size: 11px; font-weight: 400;
      color: #b5b5b5;
      transition: color 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-check.valid { color: #5a9a6a; }
    .ar-check-icon {
      width: 15px; height: 15px;
      border-radius: 50%;
      border: 1.5px solid #d4d4d4;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-check.valid .ar-check-icon { border-color: #5a9a6a; background: #5a9a6a; }
    .ar-check-icon svg { width: 9px; height: 9px; opacity: 0; transform: scale(0.5); transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
    .ar-check.valid .ar-check-icon svg { opacity: 1; transform: scale(1); }

    /* age confirmation checkbox */
    .ar-age {
      display: flex; align-items: flex-start; gap: 10px;
      margin-top: 20px; cursor: pointer;
    }
    .ar-age input[type="checkbox"] {
      appearance: none; -webkit-appearance: none;
      width: 18px; height: 18px; flex-shrink: 0;
      border: 1.5px solid rgba(7,79,79,0.3);
      background: #fff; cursor: pointer;
      position: relative; margin-top: 1px;
      transition: all 0.25s;
    }
    .ar-age input[type="checkbox"]:checked {
      background: #074F4F; border-color: #074F4F;
    }
    .ar-age input[type="checkbox"]:checked::after {
      content: '';
      position: absolute; left: 5px; top: 1px;
      width: 5px; height: 9px;
      border: solid #fff; border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
    .ar-age span {
      font-family: 'Inter', sans-serif;
      font-size: 13px; color: #2d2d2d; line-height: 1.5;
    }

    /* server error */
    .ar-server-error {
      font-family: 'Inter', sans-serif;
      font-size: 12px; color: #b33;
      background: rgba(187,51,51,0.04);
      border-left: 2px solid #C6A769;
      padding: 12px 16px;
      margin-top: 16px;
      line-height: 1.5;
    }

    /* submit */
    .ar-submit {
      width: 100%;
      height: 52px;
      margin-top: 28px;
      font-family: 'Inter', sans-serif;
      font-size: 10px; font-weight: 500;
      letter-spacing: 3.5px; text-transform: uppercase;
      color: #074F4F;
      background: #C6A769;
      border: none; cursor: pointer;
      position: relative; overflow: hidden;
      transition: transform 0.2s;
    }
    .ar-submit::before {
      content: '';
      position: absolute; inset: 0;
      background: #fff;
      transform: translateY(101%);
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-submit:hover::before { transform: translateY(0); }
    .ar-submit span { position: relative; z-index: 1; }
    .ar-submit:active { transform: scale(0.98); }

    /* redirect */
    .ar-redirect {
      text-align: center;
      margin-top: 28px;
      font-family: 'Inter', sans-serif;
      font-size: 12px; font-weight: 300; color: #8a8a8a;
    }
    .ar-redirect a {
      color: #074F4F; font-weight: 500;
      text-decoration: none; margin-left: 4px;
      position: relative; padding-bottom: 1px;
    }
    .ar-redirect a::after {
      content: '';
      position: absolute;
      bottom: 0; left: 0;
      width: 100%; height: 1px;
      background: #074F4F;
      transform: scaleX(0); transform-origin: right;
      transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .ar-redirect a:hover::after { transform: scaleX(1); transform-origin: left; }

    /* responsive */
    @media (max-width: 1024px) {
      .ar-nav-links, .ar-nav-auth { display: none; }
      .ar-nav-toggle { display: flex; }
      .ar-nav-mobile { display: flex; }
      .ar-f-grid { grid-template-columns: repeat(2, 1fr); }
    }
    @media (max-width: 900px) {
      .ar-layout {
        grid-template-columns: 1fr;
        gap: 48px;
        padding: 40px 24px;
      }
      .ar-brand { text-align: center; }
      .ar-brand-quote { max-width: 100%; }
      .ar-brand-line { margin-left: auto; margin-right: auto; }
      .ar-card { padding: 40px 28px; }
      .ar-nav-inner { padding: 20px 24px; }
      .ar-footer { padding: 60px 24px 24px; }
    }
    @media (max-width: 520px) {
      .ar-brand h1 { font-size: 36px; }
      .ar-card { padding: 32px 20px; }
      .ar-grid { grid-template-columns: 1fr; }
      .ar-f-grid { grid-template-columns: 1fr; }
    }
  `;

  const CheckIcon = () => (
    <svg viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 6l3 3 5-5"/></svg>
  );

  return (
    <div>
      <style>{css}</style>
      {/* NAV */}
      <nav className="ar-nav">
        <div className="ar-nav-inner">
          <a href="/" className="ar-nav-logo">Aware</a>
          <ul className="ar-nav-links">
            <li><a href="/">Acasă</a></li>
            <li><a href="/despre-noi">Despre noi</a></li>
            <li><a href="/servicii">Servicii</a></li>
            <li><a href="/evenimente">Evenimente</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
          <div className="ar-nav-auth">
            <a href="/login" className="ar-nav-login">Autentificare</a>
          </div>
          <button className={"ar-nav-toggle" + (mobileOpen ? " open" : "")} onClick={() => setMobileOpen((o) => !o)} aria-label="Meniu">
            <span></span><span></span><span></span>
          </button>
        </div>
        <div className={"ar-nav-mobile" + (mobileOpen ? " open" : "")}>
          <ul className="ar-nav-mobile-links">
            <li><a href="/">Acasă</a></li>
            <li><a href="/despre-noi">Despre noi</a></li>
            <li><a href="/servicii">Servicii</a></li>
            <li><a href="/evenimente">Evenimente</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
          <div className="ar-nav-mobile-auth">
            <a href="/login" className="ar-nav-login">Autentificare</a>
          </div>
        </div>
      </nav>
      <div className={"ar-nav-mobile-scrim" + (mobileOpen ? " open" : "")} onClick={() => setMobileOpen(false)} />

      <div className={"ar-scene" + (loaded ? " loaded" : "")}>
        <div className="ar-grain" />
        <div className="ar-layout">
          {/* LEFT: BRAND */}
          <div className="ar-brand">
            <div className="ar-brand-tag">Începe călătoria</div>
            <h1>Creează-ți<br />contul <em>Aware.</em></h1>
            <div className="ar-brand-line" />
            <p className="ar-brand-quote">
              „Primul pas spre schimbare este conștientizarea. Al doilea este acceptarea."
            </p>
            <div className="ar-brand-author">— Nathaniel Branden</div>
          </div>

          {/* RIGHT: FORM */}
          <div className="ar-form-wrap">
            <div className="ar-card">
              <div className="ar-card-head">
                <h2>Înregistrare</h2>
                <p>Completează datele pentru a-ți crea contul</p>
              </div>
              <RegisterForm />
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="ar-footer">
        <div className="ar-f-inner">
          <div className="ar-f-grid">
            <div className="ar-f-brand">
              <div className="ar-f-brand-name">Aware</div>
              <p>Un spațiu sigur pentru conștientizare, echilibru și sprijin emoțional.</p>
              <div className="ar-f-social">
                <a href="#">Ig</a>
                <a href="#">Fb</a>
                <a href="#">Tk</a>
              </div>
            </div>
            <div className="ar-f-col">
              <h5>Servicii</h5>
              <ul>
                <li><a href="#">Terapie Individuală</a></li>
                <li><a href="#">Terapie de Cuplu</a></li>
                <li><a href="#">Familie &amp; Parenting</a></li>
                <li><a href="#">Anxietate &amp; Depresie</a></li>
              </ul>
            </div>
            <div className="ar-f-col">
              <h5>Terapeuți</h5>
              <ul>
                <li><a href="#">Alexandra Strambeanu</a></li>
                <li><a href="#">Luna Cosmari</a></li>
                <li><a href="#">Bianca Istratescu</a></li>
                <li><a href="#">Kathrin Moculity</a></li>
              </ul>
            </div>
            <div className="ar-f-col">
              <h5>Aware</h5>
              <ul>
                <li><a href="/despre-noi">Despre noi</a></li>
                <li><a href="/#contact">Contact</a></li>
                <li><a href="/evenimente">Evenimente</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
          </div>
          <div className="ar-f-divider"></div>
          <div className="ar-f-bottom">
            <span>© 2025 Aware — Centru de Psihoterapie</span>
            <div>
              <a href="/conditii">Termeni</a>
              <a href="/confidentialitate">Confidențialitate</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Register;
